// extracted by mini-css-extract-plugin
module.exports = {"awardBox":"awards_awardBox__mpOtR","cutEdge":"awards_cutEdge__0WqQT"};